const currentCable = (state = {}, action) => {
    switch (action.type) {
        case 'SET_ACTIVE_CABLE':
            return {
                ...state,
                activeCable: action.payload,
                activeCableColor: action.payload.color,
                activeCableType: action.payload.socketType + ' Cables',
                activeCableLength: action.payload.cableLength
            };
        case 'SET_ACTIVE_CABLE_TYPE':
            return {
                ...state,
                activeCableType: action.payload
            };
        case 'SET_ACTIVE_CABLE_COLOR':
            return {
                ...state,
                activeCableColor: action.payload
            };
        case 'SET_ACTIVE_CABLE_LENGTH':
            return {
                ...state,
                activeCableLength: action.payload
            };
        default:
            return state;
    }
};

// eslint-disable-next-line
export default currentCable;
